<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import Modal from "./Modal.svelte";

  export let isOpen: boolean = false;

  const closeModal = () => {
    isOpen = false;
  };
</script>

<Modal 
  isOpen={isOpen}
  onClose={closeModal}
  closeButtonAriaLabel={$copy.rateLimited.ariaCloseButton}
  modalAriaLabel="rate-limited-modal"
  modalAriaDescription={$copy.rateLimited.ariaModalDescription}
>
  <div class="space-y-6 text-center">
    <h2 id="rate-limited-title" class="font-MrEavesXLSanNarOTUltra text-primary text-2xl lg:text-3xl font-black uppercase">
      {$copy.rateLimited.title}
    </h2>
    
    <p id="rate-limited-message" class="font-MrEavesXLSanNarOT text-white text-base lg:text-xl leading-tight">
      {$copy.rateLimited.message}
    </p>
  </div>
</Modal>
